import { Tooltip } from '@mui/material';
import { Close } from '@mui/icons-material';
import TrueFalseImage from '../../../components/TrueFalseImage';
import { GetDateInMMDDYYYYFormat } from '../../../common/utils';
import localize from '../../../common/localize';

export default function PaymentIcon({ item }) {
  return (
    <div>
      {item.PaymentDate ? (
        <Tooltip
          title={
            <div>
              {!item.Payed && (
                <p>
                  <b>{`${localize.not_payed}`}</b>
                </p>
              )}
              {item.Payed && item.PaymentMethod && (
                <p>
                  <b>{`${localize.payment_method}: `}</b>
                  {`${item.PaymentMethod.Name}`}
                </p>
              )}
              <p>
                <b>{`${
                  item.Payed ? localize.payment_date : localize.observations
                }: `}</b>
                {`${
                  item.Payed
                    ? GetDateInMMDDYYYYFormat(new Date(item.PaymentDate))
                    : item.NoPaymentObservation
                }`}
              </p>
            </div>
          }
        >
          <button>
            {item.Payed ? (
              <TrueFalseImage value />
            ) : (
              <Close style={{ color: 'red' }} />
            )}
          </button>
        </Tooltip>
      ) : (
        <TrueFalseImage iconColor="gray" />
      )}
    </div>
  );
}
